var data = { header:{ text:"#### Error",
    closeButton:true },
  body:{ text:"You've landed on our test catalog for healthcare providers.\n\nIf you are interested in getting a test for yourself, please review our <a href='/en/testing-options'>available test options listed here</a>." },
  buttons:[ { text:"Ok",
      isPrimary:true } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=patient_is_not_allowed_to_add_tests.esm.js.map
